import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearError,
  getErrorPopUpState,
} from 'src/redux/features/common/commonSlice';

const ErrorPopup: React.FC = () => {
  const dispatch = useDispatch();
  const { show, message } = useSelector(getErrorPopUpState);

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-[1700]">
      <div className="bg-white rounded-lg shadow-lg w-[400px] p-6">
        {/* Heading */}
        <h2 className="text-red-600 text-xl font-semibold mb-3">Error</h2>

        {/* Description */}
        <p className="text-gray-700 text-lg mb-6">{message}</p>

        {/* Close Button */}
        <div className="flex justify-end">
          <button
            onClick={() => dispatch(clearError())}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
